export default __webpack_public_path__ + "static/triffiq-logo-d9cc795aa86a246280ce745812554e90.svg";